const LatLng = require('../../olycommon/geolocation/latlng');

class LocationService {
    constructor(geolocation, $q) {
        this.$q = $q;
        this.geolocation = geolocation;
    }

    getCurrentLocation() {
        return this.$q((resolve, reject) => {
            this.geolocation.getCurrentPosition((position) => {
                resolve(new LatLng(position.coords));
            }, reject);
        });
    }

    isLocationEnabled() {
        return this.getCurrentLocation();
    }
}

module.exports = LocationService;



// WEBPACK FOOTER //
// ./src/olycommon/location/location.service.js